"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINT_REVOKE_TOKEN = exports.ENDPOINT_GET_TOKEN = exports.ENDPOINT_AUTHORIZATION = exports.ENDPOINT_SYNC_QUICK_ADD = exports.ENDPOINT_REST_PROJECT_COLLABORATORS = exports.ENDPOINT_REST_TASK_REOPEN = exports.ENDPOINT_REST_TASK_CLOSE = exports.ENDPOINT_REST_COMMENTS = exports.ENDPOINT_REST_LABELS_SHARED_REMOVE = exports.ENDPOINT_REST_LABELS_SHARED_RENAME = exports.ENDPOINT_REST_LABELS_SHARED = exports.ENDPOINT_REST_LABELS = exports.ENDPOINT_REST_SECTIONS = exports.ENDPOINT_REST_PROJECTS = exports.ENDPOINT_REST_TASKS = exports.getAuthBaseUri = exports.getSyncBaseUri = exports.getRestBaseUri = void 0;
var BASE_URI = 'https://api.todoist.com';
var API_REST_BASE_URI = '/rest/v2/';
var API_SYNC_BASE_URI = '/sync/v9/';
var TODOIST_URI = 'https://todoist.com';
var API_AUTHORIZATION_BASE_URI = '/oauth/';
function getRestBaseUri(domainBase) {
    if (domainBase === void 0) { domainBase = BASE_URI; }
    return new URL(API_REST_BASE_URI, domainBase).toString();
}
exports.getRestBaseUri = getRestBaseUri;
function getSyncBaseUri(domainBase) {
    if (domainBase === void 0) { domainBase = BASE_URI; }
    return new URL(API_SYNC_BASE_URI, domainBase).toString();
}
exports.getSyncBaseUri = getSyncBaseUri;
function getAuthBaseUri(domainBase) {
    if (domainBase === void 0) { domainBase = TODOIST_URI; }
    return new URL(API_AUTHORIZATION_BASE_URI, domainBase).toString();
}
exports.getAuthBaseUri = getAuthBaseUri;
exports.ENDPOINT_REST_TASKS = 'tasks';
exports.ENDPOINT_REST_PROJECTS = 'projects';
exports.ENDPOINT_REST_SECTIONS = 'sections';
exports.ENDPOINT_REST_LABELS = 'labels';
exports.ENDPOINT_REST_LABELS_SHARED = exports.ENDPOINT_REST_LABELS + '/shared';
exports.ENDPOINT_REST_LABELS_SHARED_RENAME = exports.ENDPOINT_REST_LABELS_SHARED + '/rename';
exports.ENDPOINT_REST_LABELS_SHARED_REMOVE = exports.ENDPOINT_REST_LABELS_SHARED + '/remove';
exports.ENDPOINT_REST_COMMENTS = 'comments';
exports.ENDPOINT_REST_TASK_CLOSE = 'close';
exports.ENDPOINT_REST_TASK_REOPEN = 'reopen';
exports.ENDPOINT_REST_PROJECT_COLLABORATORS = 'collaborators';
exports.ENDPOINT_SYNC_QUICK_ADD = 'quick/add';
exports.ENDPOINT_AUTHORIZATION = 'authorize';
exports.ENDPOINT_GET_TOKEN = 'access_token';
exports.ENDPOINT_REVOKE_TOKEN = 'access_tokens/revoke';
